import React from "react";
import { STAR_COUNT } from "./celebrationTiming";

const STAR_POINTS = "0,-9 2.6,-2.8 9,0 2.6,2.8 0,9 -2.6,2.8 -9,0 -2.6,-2.8";

export default function StateCelebration({ cx, cy, color }) {
  const stars = Array.from({ length: STAR_COUNT }, (_, i) => ({
    angle: (i / STAR_COUNT) * 360
  }));

  return (
    <g className="lp-celebration" transform={`translate(${cx}, ${cy})`} aria-hidden="true">
      {stars.map(({ angle }, i) => (
        <g
          key={i}
          className="lp-celebration-star"
          style={{
            "--lp-star-angle": `${angle}deg`,
            "--lp-star-color": color,
            animationDelay: `${i * 0.04}s`
          }}
        >
          <polygon points={STAR_POINTS} fill={color} />
        </g>
      ))}
      <circle className="lp-celebration-burst" r={12} fill={color} />
    </g>
  );
}
